"use client";
import { ForwardedRef, forwardRef, memo, useEffect, useState } from "react";
import useParseViewPropsToWeb from "src/hooks/useParseViewPropsToWeb";
import type LottieCoreType from "./components/LottieCore";
import { LottieHandler, LottieProps } from "./types";

const Lottie = ({ style, ...props }: LottieProps, ref: ForwardedRef<LottieHandler>) => {
	const [LottieCore, setLottieCore] = useState<typeof LottieCoreType | null>(null);
	const { style: webStyle } = useParseViewPropsToWeb({ style });

	useEffect(() => {
		import("./components/LottieCore").then((module) => {
			setLottieCore(module.default);
		});
	}, []);

	if (!LottieCore) {
		return <div style={webStyle} />;
	}
	// Using webStyle instead of style here. Don't add style otherwise you'll get redundant styles
	return <LottieCore {...props} ref={ref} webStyle={webStyle} />;
};
export default memo(forwardRef(Lottie));
